import React from 'react'
import { useTranslation } from 'react-i18next'
import { Header, Button, Grid } from 'semantic-ui-react'

import "./Section4.css"

const Section4 = () => {
    const { t } = useTranslation()
    return <div className="Section4">
        {/* <Header className="p-1-t p-1-b" size='huge'>Discover Naroon Experiences</Header> */}
        <Grid stackable columns={1}>
            <Grid.Column className="bg-host">
                <Header inverted size='huge' className="w-30 m-3-r m-3-l m-3-t">
                {t("home:QuestionsAboutHosting")}?</Header>
                <Button inverted className="m-3 rounded-10" size='big'>
                    {t("home:AskASuperhost")}
                </Button>
            </Grid.Column>
        </Grid>
    </div>
}
export default Section4